module.exports = __webpack_public_path__ + "assets/img/delete.c7a2205b.svg";